import React, { Component } from 'react';
import { Tag } from 'primereact/tag';

import { RelatedEntityGrid as EntityGrid } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelCalendar } from 'hay-core-react';
import { ModelCurrency } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import UsuarioTransacao         from '../../../models/UsuarioTransacao';
import { Usuario } from 'hay-core-react';
import Plano                    from '../../../models/Plano';
import Voucher                  from '../../../models/Voucher';
import UsuarioTransacaoTipoEnum from '../../../enums/UsuarioTransacaoTipoEnum';
import UsuarioTransacaoStatusEnum from '../../../enums/UsuarioTransacaoStatusEnum';

// ─── Mapeamento status → Tag (mesmo padrão de AuditoriaTemplate.js) ───────────

const STATUS_CONFIG = {
    'main.usuariotransacao.status.pendente':  { severity: 'warning', icon: 'pi-clock' },
    'main.usuariotransacao.status.pago':      { severity: 'success', icon: 'pi-check-circle' },
    'main.usuariotransacao.status.expirada':  { severity: 'secondary', icon: 'pi-hourglass' },
    'main.usuariotransacao.status.rejeitada': { severity: 'danger', icon: 'pi-times-circle' },
};

// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    usuario: {
        exibir:       'main.usuariotransacao.usuario',
        visivel:      true,
        tipo:         'relacao',
        camporelacao: 'nome',
        entidade:     'usuario.entidade',
        template:     'usuario.template',
    },
    plano: {
        exibir:       'main.usuariotransacao.plano',
        visivel:      true,
        tipo:         'relacao',
        camporelacao: 'descricao',
        entidade:     'plano.entidade',
        template:     'plano.template',
    },
    tipo: {
        exibir:   'main.usuariotransacao.tipo',
        visivel:  true,
        tipo:     'enum',
        entidade: 'usuariotransacao.tipo',
    },
    status: {
        exibir:   'main.usuariotransacao.status',
        visivel:  true,
        tipo:     'enum',
        entidade: 'usuariotransacao.status',
        template: 'status.template',
    },
    valor: { exibir: 'main.usuariotransacao.valor', visivel: true, tipo: 'currency' },
    datahorapagamento: { exibir: 'main.usuariotransacao.datahorapagamento', visivel: true, tipo: 'date', time: true },
    idterceiros: { exibir: 'main.usuariotransacao.idterceiros', visivel: true },
    createdAt: { exibir: 'main.createdAt', visivel: true, tipo: 'date', time: true },
    voucher: {
        exibir:       'main.usuariotransacao.voucher',
        tipo:         'relacao',
        camporelacao: 'codigo',
        entidade:     'voucher.entidade',
        template:     'voucher.template',
        hidegrid:     true,
    },
    // Corpo bruto do último retorno do MercadoPago - só pra suporte/depuração, sem coluna na grid
    // (ver formulario abaixo, renderizado como bloco de texto simples).
    ultimoretorno: { exibir: 'main.usuariotransacao.ultimoretorno', hidegrid: true },
};

// ─── Renderers customizados ───────────────────────────────────────────────────

const renderers = {
    usuario: { entidade: Usuario, template: (rowData) => rowData.usuario?.nome || rowData.usuario?.id || '' },
    plano:   { entidade: Plano,   template: (rowData) => rowData.plano?.descricao || rowData.plano?.id || '' },
    voucher: { entidade: Voucher, template: (rowData) => rowData.voucher?.codigo || '' },
    'usuariotransacao.tipo':   UsuarioTransacaoTipoEnum,
    'usuariotransacao.status': UsuarioTransacaoStatusEnum,
    status: {
        template: (rowData) => {
            const cfg = STATUS_CONFIG[rowData.status] || { severity: 'info', icon: 'pi-circle' };
            return (
                <Tag
                    severity={cfg.severity}
                    icon={`pi ${cfg.icon}`}
                    value={UtilService.traduzir(rowData.status)}
                    className="white-space-nowrap"
                />
            );
        },
    },
};

// ─── Formulário (só "Ver" - entidade gerada pelo sistema, sem create/edit) ────

class UsuarioTransacaoFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        return (
            <div className="grid">
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={model.usuario} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={model.plano} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelDropDown model={model.tipo} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelDropDown model={model.status} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelCurrency model={model.valor} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelCalendar model={model.datahorapagamento} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelTextInput model={model.idterceiros} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={model.voucher} contexto={contexto} />
                </div>
                <div className="field col-12 mt-3">
                    <label className="block mb-2">{contexto?.traduzir?.('main.usuariotransacao.ultimoretorno')}</label>
                    <pre className="surface-100 border-round p-3 text-sm" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                        {model.ultimoretorno?.value ? JSON.stringify(model.ultimoretorno.value, null, 2) : '—'}
                    </pre>
                </div>
            </div>
        );
    }
}

// ─── Template (componente exportado) ─────────────────────────────────────────

class UsuarioTransacaoTemplate extends Component {
    render() {
        return (
            <EntityGrid
                entidade={UsuarioTransacao}
                model={model}
                identidade="main.usuariotransacao"
                permissoes={this.props.permissoes}
                icone="pi-credit-card"
                storageKey="dt-usuariotransacoes"
                relacionados={[]}
                renderers={renderers}
                configuracao={this.props.configuracao}
                ordenacaoPadrao={{ sortField: 'createdAt', sortOrder: -1 }}
                formulario={(m, ctx) => <UsuarioTransacaoFormulario model={m} contexto={ctx} />}
            />
        );
    }
}

export default UsuarioTransacaoTemplate;
